import type { OrderProductStatusId } from '@witmetrics/utils';
import { API } from '@/api';
import { theme } from '@/utils/theme';

export const classes = {
  listItem: 'flex py-2',
  content: 'grow mx-2',
  details:
    'mx-4 text-sm flex flex-col font-semibold text-grey-8 dark:text-mauve-1',
  inlineDetails: 'mx-4 text-sm flex-row gap-2 mt-2',
  price: 'font-normal text-grey-7 dark:text-mauve-2',
  notes:
    'text-sm text-grey-8 dark:text-mauve-1 bg-grey-2 dark:bg-white/[0.06] rounded-md m-2 px-4 py-2',
  optionsWrapper: 'flex justify-start items-start ml-3',
  optionsIcon:
    'options-icon cursor-pointer transition-opacity text-taupe-2 dark:text-mauve-2',
};

export const styles = {
  listItem: {
    '& .options-icon': {
      opacity: 0,
    },
    '&:hover .options-icon': {
      opacity: 1,
    },
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette['grey-3'].main}`,
    },
    '.dark &:not(:last-child)': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
};

export async function updateStatus(
  orderProductId: number,
  orderProductStatusId: OrderProductStatusId
) {
  return API.Orders.updateOrderProduct(orderProductId, {
    orderProductStatusId,
  });
}
